import { QRFC } from "./QRFC";

export class QTestLinkTokenRFC extends QRFC {
  constructor() {
    super();
  }

  InitRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
  }

  GetCallName() {
    return "api/generateTestLinkToken";
  }

  SetParams(org, userid, linkUser, dl) {
    this.AddParameter("org", org);
    this.AddParameter("user", userid);
    this.AddParameter("linkUser", linkUser);
    this.AddParameter("dl", dl);
  }

  DoSessionEnded() {
    const response = JSON.parse(this.fRequest.responseText);
    this.fResolve(
      JSON.stringify({ success: false, error: true, message: response.message, token: null })
    );
  }
}
